'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:inject:callback');
}

var _invoke = require('../invoke');

/**
 * 隐藏 webview 中使用该方法返回数据
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof inject
 * @static
 * @name callback
 * @param {String} fnName 回调函数名
 * @param {String} data 返回的数据
 * @return {Undefined}
 * @example
 *  hbnb.inject.callback('funcName', 'data')
 */
module.exports = function(fnName, data) {
    if (process.env.NODE_ENV !== 'production') {
        debug('fnName is %s', fnName);
        debug('data is %s', data);
    }

    _invoke('inject', 'callback', {
        callback: fnName,
        param: data
    });
};



//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/inject/callback.js
// module id = 331
// module chunks = 0